var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSurpriseQuestion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    role: "img",
    "aria-label": "S\\xFCrpriz Soru",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "sq-face",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFC15A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FF8A1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E35A0A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "sq-inner",
    cx: 0.42,
    cy: 0.3,
    r: 0.8
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFB24C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0700F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sq-gloss",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFFFFF",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFFF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sq-box",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#F4527A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9133A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sq-lid",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FF7194"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D0244E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sq-rib",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFE68A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F7BA1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D38F08"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "sq-bow",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFE98F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E9A512"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "sq-tag",
    cx: 0.38,
    cy: 0.3,
    r: 0.8
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF0F5"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "sq-bsh",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "150%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9
  })), /*#__PURE__*/React.createElement("filter", {
    id: "sq-osh",
    x: "-30%",
    y: "-30%",
    width: "160%",
    height: "170%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 10,
    stdDeviation: 8,
    floodColor: "#5A1E00",
    floodOpacity: 0.35
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "sq-clip"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.0,20.0 L292.1,51.2 L336.7,34.2 L360.0,75.9 L407.7,75.2 L415.3,122.3 L460.4,138.0 L451.5,184.9 L488.4,215.0 L464.0,256.0 L488.4,297.0 L451.5,327.1 L460.4,374.0 L415.3,389.7 L407.7,436.8 L360.0,436.1 L336.7,477.8 L292.1,460.8 L256.0,492.0 L219.9,460.8 L175.3,477.8 L152.0,436.1 L104.3,436.8 L96.7,389.7 L51.6,374.0 L60.5,327.1 L23.6,297.0 L48.0,256.0 L23.6,215.0 L60.5,184.9 L51.6,138.0 L96.7,122.3 L104.3,75.2 L152.0,75.9 L175.3,34.2 L219.9,51.2 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(256 250) scale(0.9) translate(-256 -256)"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 16)",
    fill: "#7A2E00",
    opacity: 0.38,
    filter: "url(#sq-bsh)",
    d: "M256.0,20.0 L292.1,51.2 L336.7,34.2 L360.0,75.9 L407.7,75.2 L415.3,122.3 L460.4,138.0 L451.5,184.9 L488.4,215.0 L464.0,256.0 L488.4,297.0 L451.5,327.1 L460.4,374.0 L415.3,389.7 L407.7,436.8 L360.0,436.1 L336.7,477.8 L292.1,460.8 L256.0,492.0 L219.9,460.8 L175.3,477.8 L152.0,436.1 L104.3,436.8 L96.7,389.7 L51.6,374.0 L60.5,327.1 L23.6,297.0 L48.0,256.0 L23.6,215.0 L60.5,184.9 L51.6,138.0 L96.7,122.3 L104.3,75.2 L152.0,75.9 L175.3,34.2 L219.9,51.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(0 8)",
    fill: "#B84A05",
    d: "M256.0,20.0 L292.1,51.2 L336.7,34.2 L360.0,75.9 L407.7,75.2 L415.3,122.3 L460.4,138.0 L451.5,184.9 L488.4,215.0 L464.0,256.0 L488.4,297.0 L451.5,327.1 L460.4,374.0 L415.3,389.7 L407.7,436.8 L360.0,436.1 L336.7,477.8 L292.1,460.8 L256.0,492.0 L219.9,460.8 L175.3,477.8 L152.0,436.1 L104.3,436.8 L96.7,389.7 L51.6,374.0 L60.5,327.1 L23.6,297.0 L48.0,256.0 L23.6,215.0 L60.5,184.9 L51.6,138.0 L96.7,122.3 L104.3,75.2 L152.0,75.9 L175.3,34.2 L219.9,51.2 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#sq-face)",
    d: "M256.0,20.0 L292.1,51.2 L336.7,34.2 L360.0,75.9 L407.7,75.2 L415.3,122.3 L460.4,138.0 L451.5,184.9 L488.4,215.0 L464.0,256.0 L488.4,297.0 L451.5,327.1 L460.4,374.0 L415.3,389.7 L407.7,436.8 L360.0,436.1 L336.7,477.8 L292.1,460.8 L256.0,492.0 L219.9,460.8 L175.3,477.8 L152.0,436.1 L104.3,436.8 L96.7,389.7 L51.6,374.0 L60.5,327.1 L23.6,297.0 L48.0,256.0 L23.6,215.0 L60.5,184.9 L51.6,138.0 L96.7,122.3 L104.3,75.2 L152.0,75.9 L175.3,34.2 L219.9,51.2 Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 178,
    fill: "#C2500A",
    opacity: 0.35
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 252,
    r: 174,
    fill: "url(#sq-inner)",
    stroke: "#FFFFFF",
    strokeOpacity: 0.5,
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#sq-clip)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 256,
    cy: 118,
    rx: 210,
    ry: 112,
    fill: "url(#sq-gloss)",
    opacity: 0.55
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#sq-osh)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 262,
    width: 176,
    height: 128,
    rx: 12,
    fill: "url(#sq-box)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168,
    y: 270,
    width: 176,
    height: 12,
    fill: "#000000",
    opacity: 0.16
  }), /*#__PURE__*/React.createElement("rect", {
    x: 180,
    y: 286,
    width: 14,
    height: 92,
    rx: 7,
    fill: "#FFFFFF",
    opacity: 0.28
  }), /*#__PURE__*/React.createElement("rect", {
    x: 238,
    y: 262,
    width: 36,
    height: 128,
    fill: "url(#sq-rib)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152,
    y: 222,
    width: 208,
    height: 52,
    rx: 12,
    fill: "url(#sq-lid)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 234,
    y: 222,
    width: 44,
    height: 52,
    fill: "url(#sq-rib)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 228,
    width: 184,
    height: 11,
    rx: 5.5,
    fill: "#FFFFFF",
    opacity: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,224 C220,168 164,176 182,214 C192,234 232,232 256,224 Z",
    fill: "url(#sq-bow)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,224 C292,168 348,176 330,214 C320,234 280,232 256,224 Z",
    fill: "url(#sq-bow)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244,219 C224,194 196,196 202,212 C206,222 228,224 244,219 Z",
    fill: "#C88408",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268,219 C288,194 316,196 310,212 C306,222 284,224 268,219 Z",
    fill: "#C88408",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 256,
    cy: 223,
    rx: 19,
    ry: 15,
    fill: "#F2B11A"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 251,
    cy: 217,
    rx: 8,
    ry: 5,
    fill: "#FFFFFF",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 356,
    cy: 178,
    r: 40,
    fill: "url(#sq-tag)",
    stroke: "#E35A0A",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("text", {
    x: 356,
    y: 197,
    textAnchor: "middle",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontWeight: 700,
    fontSize: 54,
    fill: "#E35A0A"
  }, "?")), /*#__PURE__*/React.createElement("path", {
    transform: "translate(150 168) scale(20)",
    fill: "#FFFFFF",
    d: "M0,-1 C0.12,-0.12 0.12,-0.12 1,0 C0.12,0.12 0.12,0.12 0,1 C-0.12,0.12 -0.12,0.12 -1,0 C-0.12,-0.12 -0.12,-0.12 0,-1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(372 300) scale(13)",
    fill: "#FFFFFF",
    d: "M0,-1 C0.12,-0.12 0.12,-0.12 1,0 C0.12,0.12 0.12,0.12 0,1 C-0.12,0.12 -0.12,0.12 -1,0 C-0.12,-0.12 -0.12,-0.12 0,-1 Z"
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(128 290) scale(10)",
    fill: "#FFFFFF",
    opacity: 0.85,
    d: "M0,-1 C0.12,-0.12 0.12,-0.12 1,0 C0.12,0.12 0.12,0.12 0,1 C-0.12,0.12 -0.12,0.12 -1,0 C-0.12,-0.12 -0.12,-0.12 0,-1 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurpriseQuestion);
export default __webpack_public_path__ + "static/media/surprise-question.38f7833bdee614c7e9a1db4499b251b9.svg";
export { ForwardRef as ReactComponent };